import http from "./http.js";

import moment from "moment";
moment.locale("uk");

async function fetchPrivatTransactions(account, dates) {
  try {
    const { data: transactions } = await http.get(
      `/integrations/privatbank/${account}/transactions`, {
        params: dates,
      }
    );

    return transactions.map(transaction => ({
      paymentType: transaction.paymentType,
      transactionType: transaction.transactionType,
      statementFullReference: transaction.statementFullReference,
      transactionReference: transaction.transactionReference,
      statementNumber: transaction.statementNumber,
      transactionRealityType: transaction.transactionRealityType,
      paymentDocumentType: transaction.paymentDocumentType,
      paymentDocumentNumber: transaction.paymentDocumentNumber,
      currencyExchangeDate: moment(transaction.currencyExchangeDate).format("DD.MM.YYYY"),
      transactionTime: moment(transaction.transactionTime).format("DD.MM.YYYY, HH:MM"),
      amount: transaction.amount,
      currency: transaction.currency,
      beneficiaryAccount: transaction.beneficiaryAccount,
      beneficiaryName: transaction.beneficiaryName,
      beneficiaryUSREOU: transaction.beneficiaryUSREOU,
      beneficiaryMFO: transaction.beneficiaryMFO,
      addressantAccount: transaction.addressantAccount,
      addressantUSREOU: transaction.addressantUSREOU,
      addressantName: transaction.addressantName,
      addressantMFO: transaction.addressantMFO,
      addressantMFOName: transaction.addressantMFOName,
      addressantMFOCity: transaction.addressantMFOCity,
      beneficiaryMFOName: transaction.beneficiaryMFOName,
      beneficiaryMFOCity: transaction.beneficiaryMFOCity,
      reasonForPayment: transaction.reasonForPayment,
      transactionStatus: transaction.transactionStatus,
      clientDate: moment(transaction.clientDate).format("DD.MM.YYYY"),
      addressantCorrespondentAccount:
        transaction.addressantCorrespondentAccount,
      beneficiaryCorrespondentAccount:
        transaction.beneficiaryCorrespondentAccount,
      paymentService: transaction.paymentService,
      paymentServiceTransactionReference:
        transaction.paymentServiceTransactionReference,
      paymentClass: transaction.paymentClass,
      amountInNationalCurrency: transaction.amountInNationalCurrency,
      movementType: transaction.movementType,
      movementSubType: transaction.movementSubType,
      bank: transaction.bank,
      balanceAfterOperation: transaction.balanceAfterOperation,
      transactionId: transaction.transactionId,
      transactionIdString: transaction.transactionIdString,
      beneficiaryPaymentCategory: transaction.beneficiaryPaymentCategory,
      cusClientId: transaction.cusClientId,
      dealType: transaction.dealType,
      myBeneficiaryAccount: transaction.myBeneficiaryAccount,
      myBeneficiaryName: transaction.myBeneficiaryName,
      myBeneficiaryUSREOU: transaction.myBeneficiaryUSREOU,
      myBeneficiaryMFO: transaction.myBeneficiaryMFO,
      myAddressantMFOName: transaction.myAddressantMFOName,
      myAddressantMFOCity: transaction.myAddressantMFOCity,
      myCorrespondentAccount: transaction.myCorrespondentAccount,
      contractPartnerAccount: transaction.contractPartnerAccount,
      contractPartnerName: transaction.contractPartnerName,
      contractPartnerUSREOU: transaction.contractPartnerUSREOU,
      contractPartnerMFO: transaction.contractPartnerMFO,
      contractPartnerMFOName: transaction.contractPartnerMFOName,
      contractPartnerMFOCity: transaction.contractPartnerMFOCity,
      contractPartnerCorrespondentAccount:
        transaction.contractPartnerCorrespondentAccount,
      transactionDateTime: moment(transaction.transactionDateTime).format("DD.MM.YYYY, HH:MM"),
    }));
  } catch (err) {
    return [];
  }
}

async function fetchTascombankTransactions(dates) {
  try {
    const { data: transactions } = await http.get(
      "/integrations/tascombank/transactions", {
        params: dates,
      }
    );

    return transactions.map(transaction => ({
      completeAt: moment(transaction.completeAt).format("DD.MM.YYYY"),
      createdAt: moment(transaction.createdAt).format("DD.MM.YYYY"),
      debitCredit: transaction.debitCredit,
      documentNumber: transaction.documentNumber,
      id: transaction.id,
      kontragentAccount: transaction.kontragentAccount,
      kontragentBankName: transaction.kontragentBankName,
      kontragentEgrpou: transaction.kontragentEgrpou,
      kontragentMfo: transaction.kontragentMfo,
      kontragentName: transaction.kontragentName,
      mainDocumentCode: transaction.mainDocumentCode,
      mainDocumentName: transaction.mainDocumentName,
      paymentPurpose: transaction.paymentPurpose,
      subDocumentCode: transaction.subDocumentCode,
      subDocumentName: transaction.subDocumentName,
      sum: transaction.sum,
      sumEquivalent: transaction.sumEquivalent,
    }));
  } catch (err) {
    return [];
  }
}

export { fetchPrivatTransactions, fetchTascombankTransactions };
